import React from 'react';
import './sec1-error.css'
import Cta from '../components/common/cta';
import { Link } from 'react-router-dom';
const Errorsec = () => {
    return ( 
        <section className='sec1-p2-error '>
            <article className='container-sec1-p2-error'>
                <article className='text-cont-sec1-p2-error'>
                    <article className='text-error'>
                        <h1 className='header-error'>404</h1>
                        <p className='para-error'>Page not found!</p>

                        <Link to="/" class='linksss'>
                        <Cta title='Back to Home' stylee='ctaa'/>
                        </Link>
                    </article>
                </article>
            </article>
            <div className='light-effect'></div>
             <div className='rightlight-effect'></div>
           <div className="img-decoration-error"></div>
        </section>
     );
}
 
export default Errorsec;